export default __webpack_public_path__ + "static/media/NEAS0590.34I-38052_-22429_0.4fbe0049.jpg";